import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { parseInteractionDates } from 'date-time-manipulations';

import { useContentQuery, useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';
import { IntegrationProviderEnum } from 'constants-integrations';

import ContentPage from 'components/lane/ContentPage';
import RequestForm from 'components/integrations/AngusServiceRequests/RequestForm';
import MeetingForm from 'components/integrations/ProxyClick/components/MeetingForm';

export default function ContentInteractionEdit({ interaction }: any) {
  const { t } = useTranslation();
  const { content } = useContentQuery({
    contentId: interaction?.content?._id,
  });

  const isMemberUpdateEnabled = useFlag(
    FeatureFlag.MemberInteractionUpdate,
    false
  );

  const editingInteraction = useMemo(
    () =>
      isMemberUpdateEnabled ? parseInteractionDates(interaction) : undefined,
    [isMemberUpdateEnabled, interaction]
  );

  const integrationProvider = content?.integration?.integration?.name;

  switch (integrationProvider) {
    case IntegrationProviderEnum.ProxyClick:
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ content: any; interaction: any; }' is not ... Remove this comment to see the full error message
      return <MeetingForm content={content} interaction={interaction} />;
    case IntegrationProviderEnum.AngusServiceRequests:
      return <RequestForm content={content} interaction={interaction} />;
    default:
      if (!isMemberUpdateEnabled || !content || !editingInteraction) {
        return null;
      }

      return (
        <ContentPage
          content={content}
          editingInteraction={editingInteraction}
          submitButtonLabel={t('Update')}
        />
      );
  }
}
